import React from 'react'; //, { useState }
import { Route, Switch, Redirect } from 'react-router-dom';
import './dashboard.scss';
import TwitterIcon from '../../../assets/images/twitterIcon.svg';
import InstagramIcon from '../../../assets/images/instagramIcon.svg';
import LinkedInIcon from '../../../assets/images/linkedInIcon.svg';
import YouTubeIcon from '../../../assets/images/youtubeIcon.svg';
// import { useHistory } from "react-router-dom";
import ShopItemPage from '../../shop-item';
// import SettingsIcon from "@material-ui/icons/Settings";
// import ExitToAppIcon from "@material-ui/icons/ExitToApp";
// import RadioIcon from "@material-ui/icons/Radio";
import Sidebar from './components/side-bar/Sidebar';

import ShopPage from '../../shop';

import DashboardSamplesPage from '../samples/';
import DashboardSyncPage from '../sync/';
import DashboardProfilePage from '../profile';
import DashboardInvoicesPage from '../invoices';
import Header from '../../../components/header';  
import DashboardOneSyncPage from '../one-sync';
import DashboardOneSamplePage from '../one-sample';
import DashboardSecurityPage from '../security';
const Dashboard = () => {
  // const history = useHistory();
  // const [activeSection, setActiveSection] = useState("");

  const headerMenu = [
    'CLEAR SAMPLES',
    'REVIEW',
    'DIGITAL LICENSES',
    'SAMPLE EXCHANGE',
    'TESTMONIALS',
    'GROOVES',
  ];

  const overviewList = [
    'Music Clearance',
    'Terms & Conditions',
    'Pricing',
    'Interviews',
  ];

  const menuList = ['About us', 'Contact us', 'Grooves', 'Sample Review'];

  const socials = ['Youtube', 'Twitter', 'Instagram', 'Linkdln'];

  // const handelNavigate = (path) => {
  //   history.push(path);
  // };
  return (
    <div className="profile">
      {/* new user dashboard header */}
      <Header />
      {/* <div className="profile-header">
        <h2 className="header-logo">AMPLE SAMPLES</h2>
        <h4 className="header-right-icon">
          <div className="header-profile-img">
            <img src="https://picsum.photos/20/20" />
          </div>
          Hi !
        </h4>
      </div> */}

      <div className="profile-container">
        <Sidebar />
        {/* sifting sidebar to Sidebar component */}
        {/* <div className="side-menu">
          <div className="side-menu-profile-img">
            <div className="profile-wrapper">
              <img src="https://picsum.photos/150/150" />
            </div>
          </div>
          <ul className="side-menu-wrapper">
            <li className="menu-items" onClick={() => setActiveSection("")}>
              <img src={TwitterIcon} className="social-icons" />
              MY SAMPLES
            </li>
            <ul className="sub-menu-items">
              <li className="sub-items">
                <img src={TwitterIcon} className="sub-social-icons" />
                Samples
              </li>
              <li className="sub-items">
                <RadioIcon className="sub-social-icons" />
                Sync
              </li>
            </ul>

            <li className="menu-items">
              <img src={TwitterIcon} className="social-icons" />
              ACCOUNT SETTINGS
            </li>
            <li
              className="menu-items"
              // onClick={() => handelNavigate("/subscriptions")}
              onClick={() => setActiveSection("SUBSCRIPTIONS")}
            >
              <SettingsIcon className="social-icons" />
              SERVICES
            </li>
            <li className="menu-items">
              <img src={TwitterIcon} className="social-icons" />
              TRANSACTIONS <span className="order-count">0</span>
            </li>
            <li className="menu-items">
              <ExitToAppIcon className="social-icons" />
              LOGOUT
            </li>
          </ul>
        </div> */}
        <div className="profile-details">
          {/* user dashboard routes setup */}
          <Switch>
            <Redirect
              exact
              from="/userdashboard"
              to="/userdashboard/mysamples"
            />
            <Route index path="/userdashboard/mysamples">
              <DashboardSamplesPage />
            </Route>
            <Route index path="/userdashboard/mysyncs">
              <DashboardSyncPage />
            </Route>
            <Route path="/userdashboard/settings">
              <DashboardProfilePage />
            </Route>
            <Route path="/userdashboard/samples/:id">
              <DashboardOneSamplePage />
            </Route>
            <Route path="/userdashboard/sync-detail/:id">
              <DashboardOneSyncPage />
            </Route>

            <Route path="/userdashboard/security">
              <DashboardSecurityPage />
            </Route>

            <Route path="/userdashboard/transactions">
              <DashboardInvoicesPage />
            </Route>
          

            <Route path="/userdashboard/subscriptions">
              <ShopItemPage userDashboardView={true} />
            </Route>
            <Route path="/cart">
              <ShopPage />
            </Route>
            {/* <Route path="/userdashboard/subscription/:plan">
              <ShopPage userDashboardView={true} />
            </Route> */}
          </Switch>
        </div>
      </div>
      <div className="profile-footer">
        <div className="overview">
          <h3>OVERVIEW</h3>
          <div className="footer-links">
            {overviewList?.map((list, index) => (
              <div className="link-list" key={index}>
                {list}
              </div>
            ))}
          </div>
        </div>
        <div className="menu">
          <h3>MENU</h3>
          <div className="footer-links">
            {menuList?.map((list, index) => (
              <div className="link-list" key={index}>
                {list}
              </div>
            ))}
          </div>
        </div>
        <div className="socials">
          <h3>SOCIALS</h3>
          <div className="footer-links">
            {socials?.map((list, index) => (
              <div className="link-list" key={index}>
                {list}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
